/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/prefer-default-export
export enum InviteRestrictionReason {
  NoAvailableLicences = "noavailablelicences",
  InvitesRestricted = "invitesnotallowed",
  AssessDeadlineExpired = "assessdeadlineexpired",
  InviteExpired = "inviteexpired",
}
